import AbstractField from "./AbstractField";

export default class DataTable extends AbstractField {
    attributes = [
        'Light requirement',
        'Water requirement',
        'Soil type',
        'Spacing',
        'Layer',
        'Height',
        'Width',
    ];

    populate(species) {
        this.tBody.html('');
        let header = null;
        this.attributes.map((attr) => {
            let value = species[attr];
            if (value && value != 'not specified') {
                header ??= this.createHeader(); // Only create header when there will be data to show
                let row = this.p.createElement('tr').parent(this.tBody);
                this.p.createElement('th', attr).parent(row);
                this.p.createElement('td', Array.isArray(value)
                    ? value.join(', ')
                    : value)
                    .parent(row);
            }
        });
    }

    make() {
        this.field = this.p.createDiv().class('input-group');
        this.parentElement ? this.field.parent(this.parentElement) : null;
        this.table = this.p.createElement('table').class('table-data')
            .parent(this.field);
        this.tBody = this.p.createElement('tbody').parent(this.table)
            .style('width', '100%');
        this.initialized = true;
        return this;
    }

    createHeader() {
        let header = this.p.createElement('tr').parent(this.tBody);
        this.p.createElement('th', 'Attributes')
            .parent(header)
            .attribute('colspan', 2)
            .style('background-color', '#1B2223')
            .style('color', '#B8E9E4');
        return header;
    }
}
